export default function (...args)
{
	return {

		events: ['change'],

		getValue(default_value = document.querySelector(this.selector).hasAttribute('checked') ? 1 : 0, _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		setValue(value, _this = this)
		{
			// '0' é string truthy em JS — não usar "value ? 1 : 0" (quebrava checkboxes com '0'/'1' do JSON/API).
			const on = value === true || value === 1 || value === '1';
			this.safeProtoCall(on ? 1 : 0, _this);
		},

		isEmpty(value = this.getValue())
		{
			return value == 0;
		},

		refresh()
		{
			let node = document.querySelector(this.selector);
			if (node)
				node.checked = this.getValue() != 0;
		},

		handleEvents(ev)
		{
			this.setValue(ev.target.checked ? 1 : 0);
		}

	};
}

